import "./ApplicationConsultation.module.css";
import Header from "@/reusable_sections/Header";
import ConsultationHero from "./sections/ConsultationHero";
import Deliverables from "./sections/Deliverables";
import Methodology from "./sections/Methodology";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function ApplicationConsultationPage() {
  return <div>
      <Header />
      <ConsultationHero />
      <Deliverables />
      <Methodology />
      <Consultation />
      <Footer />
    </div>;
}